<!--
 * @Description: 查看教学设计
 * @Author: PF
 * @Date: 2024-01-04 14:50:25
 * @LastEditors: PF
 * @LastEditTime: 2024-07-26 16:19:35
-->
<template>
  <div>
    <el-dialog class="w850 hp80" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">查看教学设计</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="学期" label-align="right" align="left" width="140px" span="2">{{ruleForm.xqmc}}</el-descriptions-item>
        <el-descriptions-item label="课程" label-align="right" align="left" width="100px" span="2">{{ruleForm.kcmc}}</el-descriptions-item>
        <el-descriptions-item label="周次" label-align="right" align="left" span="2">第{{ruleForm.zc}}周</el-descriptions-item>
        <el-descriptions-item label="状态" label-align="right" align="left" span="2"><span v-if="ruleForm.zt">{{ruleForm.zt.name}}</span></el-descriptions-item>
        <el-descriptions-item label="班级/节次 " label-align="right" align="left" span="4">
          <span>{{ruleForm.bjmc}} / 星期{{week[ruleForm.xq]}} 第{{ruleForm.jc}}节</span>
        </el-descriptions-item>
        <el-descriptions-item label="教学单元" label-align="right" align="left" width="140px" span="2">{{ruleForm.jxdybt}}</el-descriptions-item>
        <el-descriptions-item label="教学内容" label-align="right" align="left" width="140px" span="2">{{ruleForm.jxnrbt}}</el-descriptions-item>
        <el-descriptions-item v-for="(item, index) in ruleForm.jxsjmb" :key="index" :label="item.mbzdmc" label-align="right" align="left" span="4">
          <p style="white-space: pre-wrap; text-indent:0;" v-html="item.nr"></p>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { warningPrompt } from '@/utils/promptInfo'
import { closeWindow, actionPost } from '@/api/common.js'
const emits = defineEmits(['update:openDetail', 'ReturnData'])
const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})

const ruleForm = ref({ jxsjmb: [] })
const week = ref(['', '一', '二', '三', '四', '五', '六', '日'])
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      // 获取详情
      actionPost({
        url: '/api/v2/jiaowu/jiaowujiaoxuesheji/' + props.row.id,
        data: {}
      }).then((res) => {
        if (res.code === 200) {
          ruleForm.value = res.data
          ruleForm.value.jxsjmb = []
          ruleForm.value.jxsjmb = ruleForm.value.jxsjnrs ? ruleForm.value.jxsjnrs.map(item => { item.zdlx = item.zdlx ? item.zdlx.value : ''; return item }) : []
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)

</script>
